export type PlannedScorecardPlayer = { slot: number; playerId: string; name: string };
export type ActualScorecardPlayer = { slot: number; playerId: string | null; name: string; unresolved: boolean };

export function scorecardPlayers(
  planned: PlannedScorecardPlayer[],
  actual: ActualScorecardPlayer[] | undefined,
  lineupPublished: boolean,
) {
  const plannedInOrder = [...planned].sort((a, b) => a.slot - b.slot);
  const actualInOrder = [...(actual || [])].sort((a, b) => a.slot - b.slot);
  return {
    shown: actualInOrder.length ? actualInOrder : plannedInOrder.map(player => ({ ...player, unresolved: false })),
    changed: lineupPublished && actualInOrder.length > 0 && plannedInOrder.length > 0
      && (actualInOrder.length !== plannedInOrder.length || plannedInOrder.some(player => actualInOrder.find(item => item.slot === player.slot)?.playerId !== player.playerId)),
    planned: plannedInOrder,
  };
}

export function scorecardWinner(
  winner: 'Us' | 'Opponent' | 'Unknown',
  officialOurName: string | null | undefined,
  officialOpponentName: string | null | undefined,
  fallbackOurName: string,
  fallbackOpponentName: string,
) {
  if (winner === 'Us') return { label: officialOurName?.trim() || fallbackOurName, color: 'success' as const };
  if (winner === 'Opponent') return { label: officialOpponentName?.trim() || fallbackOpponentName, color: 'error' as const };
  return { label: 'Pending', color: 'default' as const };
}
